var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { isEmpty as _isEmpty, trim as _trim, each as _each } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { convertFromActionFunctionConfigToProps } from '../../types';
import { updateConversation } from '../../components/utils/localStorage';
import { ChunkType } from '../../api/types';
import { getQuery } from '../../api/query';
import { FAILURE_CHUNK_MESSAGE, getActionFunctionFromChunk, getChunkValue } from '../../api/helpers';
export var MessagesActionType;
(function (MessagesActionType) {
    MessagesActionType["ADD_MESSAGE"] = "ADD_MESSAGE";
    MessagesActionType["UPDATE_MESSAGE"] = "UPDATE_MESSAGE";
    MessagesActionType["CLEAR_MESSAGE"] = "CLEAR_MESSAGE";
    MessagesActionType["DELETE_ALL_MESSAGES"] = "DELETE_ALL_MESSAGES";
    MessagesActionType["UPDATE_STATUS"] = "UPDATE_STATUS";
    MessagesActionType["CLEAR_STATUS"] = "CLEAR_STATUS";
    MessagesActionType["ADD_INITIAL_VIF_PROMPT"] = "ADD_INITIAL_VIF_PROMPT";
    MessagesActionType["HANDLE_MESSAGE_SEND"] = "HANDLE_MESSAGE_SEND";
    MessagesActionType["UPDATE_LOCAL_STORAGE_MESSAGES"] = "UPDATE_LOCAL_STORAGE_MESSAGES";
})(MessagesActionType || (MessagesActionType = {}));
export const addMessage = createAction(MessagesActionType.ADD_MESSAGE);
export const updateMessage = createAction(MessagesActionType.UPDATE_MESSAGE);
export const clearMessage = createAction(MessagesActionType.CLEAR_MESSAGE);
export const deleteAllMessages = createAction(MessagesActionType.DELETE_ALL_MESSAGES);
export const updateStatus = createAction(MessagesActionType.UPDATE_STATUS);
export const clearStatus = createAction(MessagesActionType.CLEAR_STATUS);
export const addInitialVifPrompt = createAction(MessagesActionType.ADD_INITIAL_VIF_PROMPT);
export const updateLocalStorageMessages = createAsyncThunk(MessagesActionType.UPDATE_LOCAL_STORAGE_MESSAGES, (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { getState }) {
    const { messages: { messages }, } = getState();
    updateConversation(JSON.stringify(messages));
}));
export const handleMessageSend = createAsyncThunk(MessagesActionType.HANDLE_MESSAGE_SEND, (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ inputText, mode, actionFunction, proxyApp, appContext, updateScrolling }, { dispatch, getState }) {
    const { appConfiguration: { listOfBannedWords, redactedText }, messages: { messages }, } = getState();
    const question = _trim(inputText);
    if (_isEmpty(question)) {
        return;
    }
    let hasMessageErroredOut = false;
    const newMessage = {
        messageId: uuidv4(),
        question,
        isResponseCompleted: false,
        response: '',
    };
    dispatch(addMessage(newMessage));
    updateScrolling(true);
    const censoringInfo = { redactedText, listOfBannedWords };
    const conversationHistory = [...messages, newMessage].map(({ messageId, question, response }) => ({
        messageId,
        question,
        response,
    }));
    const queryParameters = {
        conversation: conversationHistory,
        onData: (chunk, isResponseCompleted = false) => {
            let processedChunk = getChunkValue(chunk, censoringInfo);
            let actionFunctionConfigs = [];
            try {
                actionFunctionConfigs = getActionFunctionFromChunk(chunk);
            }
            catch (error) {
                processedChunk = { type: ChunkType.ERROR, value: FAILURE_CHUNK_MESSAGE };
            }
            if (hasMessageErroredOut) {
                if (processedChunk.type === ChunkType.ERROR) {
                    dispatch(updateMessage({ messageId: newMessage.messageId, responseChunk: processedChunk.value, isResponseCompleted }));
                }
            }
            else {
                switch (processedChunk.type) {
                    case ChunkType.ERROR:
                        dispatch(clearMessage(newMessage.messageId));
                        hasMessageErroredOut = true;
                        dispatch(updateMessage({ messageId: newMessage.messageId, responseChunk: processedChunk.value, isResponseCompleted }));
                        break;
                    case ChunkType.MESSAGE:
                        dispatch(updateMessage({ messageId: newMessage.messageId, responseChunk: processedChunk.value, isResponseCompleted }));
                        break;
                    case ChunkType.PROGRESS_STATUS:
                        dispatch(updateStatus(processedChunk.value));
                        break;
                }
                if (processedChunk.type !== ChunkType.ERROR) {
                    setTimeout(() => {
                        if (!_isEmpty(actionFunctionConfigs) && actionFunction) {
                            _each(actionFunctionConfigs, (functionConfig) => {
                                const actionFunctionProps = Object.assign({ functionType: functionConfig.name }, functionConfig.args);
                                if (convertFromActionFunctionConfigToProps(actionFunctionProps)) {
                                    actionFunction(actionFunctionProps);
                                }
                            });
                        }
                    }, 1000);
                }
            }
            if (isResponseCompleted) {
                dispatch(clearStatus());
            }
        },
    };
    try {
        yield getQuery(queryParameters, proxyApp, appContext, mode);
        yield dispatch(updateLocalStorageMessages());
    }
    catch (error) {
        dispatch(clearMessage(newMessage.messageId));
        dispatch(updateMessage({ messageId: newMessage.messageId, responseChunk: FAILURE_CHUNK_MESSAGE, isResponseCompleted: true }));
    }
}));
//# sourceMappingURL=messages.js.map